const jsEncryptWrapper = require('../assets/script/jsencrypt');
const jsEncrypt = {
  getEncryptObj_msw() {
    const publickey = `-----BEGIN PUBLIC KEY-----
                MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJySbJbk2PVbMzgzyXzGoRIURG
                CCN5PSi/ve+AaQY2KqwnoOrilOaaojuvseN78xrBmwpR5cIPVNj733lKD6MxUWrw
                69qgyrUA6YRB8K5ICbPQcYwr32b4z8NqLp3nDd1x1EmCoc5LkTxdhGBvXO2BjXvk
                cGR3LTh8ScrVCRBnHwIDAQAB
                -----END PUBLIC KEY-----
                `;
    const encrypt = new jsEncryptWrapper();
    encrypt.setPublicKey(publickey);
    return encrypt;
  },
  getEncryptObj_spog() {
    const publickey = `-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDzuU/w5RViQHjD5x88HVfiiq7A
    qThMGm+LRZMiSZnVYhEiXozOEWAq3Ir5Pirb4b6fqeHX6+a+EJKNgPwJJz56XqtE
    881Uqo0Mtv8N1E0XWvlDsfjbl2OF/DUmYlNrcXSHJzB0yMz86y3MifHDm1l1hqHb
    BlZHIMgb/lapRy9BRQIDAQAB
    -----END PUBLIC KEY-----`;
    const encrypt = new jsEncryptWrapper();
    encrypt.setPublicKey(publickey);
    return encrypt;
  },
};
export default jsEncrypt;
